import { HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { exhaustMap, map, take } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromApp from '../store/app.reducer';
import { environment } from '../../environments/environment';


@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
  constructor(private store: Store<fromApp.AppState>) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return this.store.select('auth').pipe(
      take(1),
      map((authState) => authState.user),
      exhaustMap((user) => {
        if (!user) {
          return next.handle(req);
        }

        if (!req.url.startsWith(environment.apiUrl)) {
          return next.handle(req);
        }

        const modifiedReq = req.clone({
          // params: new HttpParams().set('auth', user.token || ''),
          setHeaders: {
            Authorization: `Token ${user.token}`,
          },
        });
        return next.handle(modifiedReq);
      })
    );
  }
}
